import React from 'react';
import { SaveIcon } from '@econsult/econsult-ui/dist/assets';
import { FlexGroup, GenericEcButton, StyledDeleteIcon } from './styles';

interface EditInputControlsProps {
  handleSave: () => void;
  handleDiscard: () => void;
  isSaveButtonDisabled?: boolean;
}

export const EditInputControls: React.FC<EditInputControlsProps> = ({
  handleDiscard,
  handleSave,
  isSaveButtonDisabled = false,
}) => (
  <FlexGroup data-automation="Edit-Button-Group">
    <GenericEcButton
      fillStyle="ghost"
      size="small"
      variant="primary"
      iconPosition="left"
      icon={<StyledDeleteIcon />}
      data-automation="Button-Discard-Edit"
      onClick={handleDiscard}
    >
      Discard
    </GenericEcButton>
    <GenericEcButton
      fillStyle="ghost"
      size="small"
      variant="primary"
      iconPosition="left"
      icon={<SaveIcon />}
      data-automation="Button-Save-Edit"
      disabled={isSaveButtonDisabled}
      onClick={handleSave}
    >
      Save
    </GenericEcButton>
  </FlexGroup>
);
